<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-cabinet-filing">
      Space Fragments
      <template v-slot:buttons>
        <v-btn color="primary"
               @click.prevent="createFragment"
               :disabled="busy"
               class="mr-4">
          New Fragment
        </v-btn>

        <v-btn :to="{name: 'admin.spaces.index'}"
               exact>
          Spaces
        </v-btn>
      </template>
    </page-title>

    <v-card class="mb-4">
      <v-simple-table>
        <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Title
          </th>
          <th>
            Language
          </th>
          <th>
            Status
          </th>
          <th>
            Spaces
          </th>
          <th>
            Collapsed Height
          </th>
          <th>
            Updated
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="fragment in fragments"
            :key="fragment.id">
          <td class="text-no-wrap">
            <router-link :to="{name: 'admin.space_fragment.edit', params: {fragmentID: fragment.id}}">
              {{ fragment.name }}
            </router-link>
          </td>
          <td class="text-no-wrap">
            {{ fragment.dialog_title }}
          </td>
          <td class="text-no-wrap">
            {{ fragment.locale_name }}
          </td>
          <td class="text-no-wrap">
            <v-chip :color="fragment.is_active ? 'success' : 'warning'"
                    small
                    label>
              {{ fragment.status }}
            </v-chip>
          </td>
          <td class="text-no-wrap">
            <v-tooltip v-if="fragment.spaces?.length"
                       top>
              <template v-slot:activator="{on, attrs}">
                <div v-bind="attrs"
                     v-on="on">
                  {{ fragment.spaces.length | pluralize('space') }}
                </div>
              </template>
              <div>
                <div v-for="space in fragment.spaces"
                     :key="space.id">
                  {{ space.name }}
                </div>
              </div>
            </v-tooltip>
            <template v-else>
              None
            </template>
          </td>
          <td class="text-no-wrap">
            {{ fragment.collapsed_height }}
          </td>
          <td class="text-no-wrap">
            {{ fragment.updated_at | datetime }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card>

  </v-container>
</template>
<script>
import spaceService from '../../services/spaceService';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  data() {
    return {
      busy: false,
      fragments: [],
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.busy = true;
      spaceService.getFragments()
        .then(data => {
          this.fragments = data;
        })
        .finally(() => {
          this.busy = false;
        })
    },
    createFragment() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      this.error = null;
      return spaceService.createFragment()
        .then(fragment => {
          this.$router.push({name: 'admin.space_fragment.edit', params: {fragmentID: fragment.id}});
        })
        .catch(err => {
          this.error = err;
        })
        .finally(() => {
          this.busy = false;
        })
    },
  }
}
</script>
